<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 8 60"
		class="sub-resource-divider"
	>
		<g id="divider-menu-top">
			<polygon class="cls-2" points="4 4 4 56 0 60 0 0 4 4" />
			<polygon class="cls-1" points="8 0 8 60 4 56 4 4 8 0" />
			<polygon class="cls-2" points="8 0 4 4 0 0 8 0" />
			<polygon class="cls-1" points="8 60 0 60 4 56 8 60" />
		</g>
	</svg>
</template>

<style lang="scss" scoped>
.sub-resource-divider {
	width: 0.25rem;
	height: 1.75rem;

	.cls-1 {
		fill: #464550;
	}
	.cls-2 {
		fill: #111015;
	}
}
</style>
